import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './breadcrumb.module.scss'

const Breadcrumb = ({ items }) => {
  return (
    <ul className={styles.breadcrumbContainer}>
      {items.map((item) =>
        item.path ? (
          <Link key={item.id} to={item.path}>
            {item.title}
          </Link>
        ) : (
          <li key={item.id}>{item.title}</li>
        )
      )}
    </ul>
  )
}

Breadcrumb.defaultProps = {
  items: []
}

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired
    })
  )
}

export default Breadcrumb
